const N = "table/SET_CURRENT_PAGINATION_NUMBER";
export {
  N as SET_CURRENT_PAGINATION_NUMBER
};
//# sourceMappingURL=types.js.map
